import { useEffect, useState } from "react";
import { Button, Form, Input, Radio, Select, Switch } from "antd";
import { PlusOutlined, MinusOutlined, DeleteOutlined } from "@ant-design/icons";
import globalRequest from "../../../../../utils/global/globalRequest";
import * as Validation from "../../../../../utils/helper/validation";
import * as Apis from "../../../../../utils/helper/enum";
import toast from "react-hot-toast";
import { changeLoader } from "../../../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const ModifierGroupType = () => {
  let { id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [allVendor, setAllVendor] = useState([]);
  const [allModifierType] = useState([
    {
      value: "single",
      label: "Single",
    },
    {
      value: "multiple",
      label: "Multiple",
    },
  ]);

  const [forCustom, setForCustom] = useState(0); // State to track Radio value
  const [active, setActive] = useState(1);
  const [countMinimum, setCountMinimum] = useState(0);
  const [countMaximum, setCountMaximum] = useState(1);
  const [formItems, setFormItems] = useState([
    {
      itemid: 0,
      item_name_english: "",
      item_name_arabic: "",
      price: "",
      prep_time: "",
    },
  ]);

  const handleMinimumIncrease = () => {
    setCountMinimum(countMinimum + 1);
    form.setFields([
      {
        name: "minimum",
        errors: [],
      },
    ]);
  };

  const handleMinimumDecrease = () => {
    if (countMinimum < 1) return true;
    setCountMinimum(countMinimum - 1);
    form.setFields([
      {
        name: "minimum",
        errors: [],
      },
    ]);
  };

  const handleMaximumIncrease = () => {
    setCountMaximum(countMaximum + 1);
    form.setFields([
      {
        name: "maximum",
        errors: [],
      },
    ]);
  };

  const handleMaximumDecrease = () => {
    if (countMaximum < 1) return true;
    setCountMaximum(countMaximum - 1);
    form.setFields([
      {
        name: "maximum",
        errors: [],
      },
    ]);
  };

  const handleAddMore = () => {
    setFormItems([
      ...formItems,
      {
        itemid: 0,
        item_name_english: "",
        item_name_arabic: "",
        price: "",
        prep_time: "",
      },
    ]);
  };

  const handleRemove = (index) => {
    let newArr = [...formItems];
    newArr = newArr.filter((_, idx) => idx !== index);

    form.setFieldValue(`Name_English_${index}`, undefined);
    form.setFieldValue(`Name_Arabic_${index}`, undefined);
    form.setFieldValue(`Price_${index}`, undefined);
    form.setFieldValue(`Prep_Time_${index}`, undefined);

    for (let i = 0; i < newArr?.length; i++) {
      form.setFieldValue(`Name_English_${i}`, newArr[i].item_name_english);
      form.setFieldValue(`Name_Arabic_${i}`, newArr[i].item_name_arabic);
      form.setFieldValue(`Price_${i}`, newArr[i].price);
      form.setFieldValue(`Prep_Time_${i}`, newArr[i].prep_time);
    }

    setFormItems(newArr);
  };

  const handleSubmit = async (values) => {
    values.maximum = countMaximum;
    values.minimum = countMinimum;

    if (values.maximum < values.minimum) {
      form.setFields([
        {
          name: "maximum",
          errors: ["Max should greater then or equal to min."],
        },
      ]);
      return false;
    }

    if (formItems.length < values.maximum) {
      toast.error("You need to add more item of your max value.");
      return false;
    }

    let insertData = {
      vendor_id: values.vendor_id,
      name_english: values.name_english,
      name_arabic: values.name_arabic,
      for_custom: values.for_custom, //1,0
      question_order: values.question_order, // if forcustom 1 then only we need this field
      type: values.type,
      min: values.minimum,
      max: values.maximum,
      status: active === 1 ? "active" : "inactive",
      items: formItems,
    };

    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_MODIFIERES?.CREATE_MODIFIER;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_MODIFIERES?.EDIT_MODIFIER + "/" + id;
        method = "put";
      }
      let response = await globalRequest(url, method, insertData, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Modifiers created successfully";
        if (id) msg = "Modifiers updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        sessionStorage.setItem('previousPath', location.pathname);
        navigate("/manage-modifiers");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getAllVendor = async () => {
    try {
      let response = await globalRequest(Apis.MANAGE_MODIFIERES.GET_ALL_VENDOR_LIST, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (apiResponse.data) {
        let data = apiResponse?.data?.map((item) => {
          return {
            value: item?.id,
            label: item?.vendorDetail?.storeName,
          };
        });
        setAllVendor(data);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    getAllVendor();
    if (id) getModifierDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getModifierDetail = async (id) => {
    try {
      let response = await globalRequest(Apis.MANAGE_MODIFIERES.GET_MODIFIER_DETAIL + "/" + id, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;

        setCountMaximum(data.max);
        setCountMinimum(data.min);

        form.setFieldValue("question_order", data?.question_order);
        form.setFieldValue("type", data?.type);
        form.setFieldValue("vendor_id", data?.vendorId);
        form.setFieldValue("for_custom", data?.forCustom);
        form.setFieldValue("question_order", data?.order);
        setForCustom(data?.forCustom);

        for (let i in data.modifierGroupLocales) {
          if (data.modifierGroupLocales[i].languageCode === "en") form.setFieldValue("name_english", data?.modifierGroupLocales[i]?.name);
          if (data.modifierGroupLocales[i].languageCode === "ar") form.setFieldValue("name_arabic", data?.modifierGroupLocales[i]?.name);
        }

        if (data.status === "active") setActive(1);
        else setActive(0);

        let itemsData = [];
        for (let i in data.modifierGroupItems) {
          let localNameEn = "";
          let localNameAr = "";
          for (let j in data?.modifierGroupItems[i].modifierGroupItemLocales) {
            if (data?.modifierGroupItems[i].modifierGroupItemLocales[j].languageCode === "en")
              localNameEn = data?.modifierGroupItems[i].modifierGroupItemLocales[j].name;
            if (data?.modifierGroupItems[i].modifierGroupItemLocales[j].languageCode === "ar")
              localNameAr = data?.modifierGroupItems[i].modifierGroupItemLocales[j].name;
          }
          itemsData.push({
            itemid: data.modifierGroupItems[i].id,
            item_name_english: localNameEn,
            item_name_arabic: localNameAr,
            price: data.modifierGroupItems[i].price,
            prep_time: data.modifierGroupItems[i].prepTime,
          });

          form.setFieldValue(`Name_English_${i}`, localNameEn);
          form.setFieldValue(`Name_Arabic_${i}`, localNameAr);
          form.setFieldValue(`Price_${i}`, data.modifierGroupItems[i].price);
          form.setFieldValue(`Prep_Time_${i}`, data.modifierGroupItems[i].prepTime);
        }
        setFormItems(itemsData);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  // handle change formItems
  const handleChangeFormItems = (key, value, index) => {
    setFormItems((prevFormItems) => prevFormItems.map((item, idx) => (idx === index ? { ...item, [key]: value } : item)));
  };

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  return (
    <>
      <div className="min-h-[calc(100vh_-_305px)]">
        <h4 className="text-[16px] font-semibold">Modifier Group & Type</h4>
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          style={{
            maxWidth: 1000,
            width: "100%",
          }}
          initialValues={{
            remember: true,
            for_custom: 0,
          }}
          autoComplete="off"
        >
          <div className="my-4">
            <Form.Item
              label="Vendor"
              name="vendor_id"
              rules={[
                {
                  required: true,
                  type: "number",
                  message: "Please select your Vendor.",
                },
              ]}
            >
              <Select
                style={{
                  width: 200,
                }}
                placeholder="Choose vendor"
                options={allVendor}
                showSearch
                filterOption={(input, allVendor) => (allVendor?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                className="mx-1.5 cursor-pointer"
              />
            </Form.Item>
          </div>
          <div className="my-4">
            <h4 className="text-[16px] font-semibold">Choose in which you want to add this, modifier type or custom question type.</h4>
            <Form.Item
              label=""
              name="for_custom"
              rules={[
                {
                  required: true,
                  type: "number",
                  message: "Please select modifier type.",
                },
              ]}
            >
              <Radio.Group className="my-4" onChange={(e) => setForCustom(e.target.value)}>
                <Radio value={0}>Modifier type</Radio>
                <Radio value={1}>Custom question type</Radio>
              </Radio.Group>
            </Form.Item>
            {forCustom === 1 && ( // Conditionally render based on forCustom state
              <Form.Item
                label="Question Order"
                name="question_order"
                rules={[
                  {
                    required: true,
                    message: "Please enter your question order.",
                  },
                ]}
              >
                <Input
                  size="large"
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value, "number");
                    form.setFieldValue("question_order", value.trimStart());
                    handleInputChange("question_order");
                  }}
                />
              </Form.Item>
            )}
          </div>
          <div className="my-4">
            <h4 className="text-[16px] font-semibold">What type of modifier group you want to create?</h4>
            <p className="text-[#808080] text-sm">
              Modifier group name like Choose a flavour, Choose a size, Choose from Choice of Filling.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4">
              <Form.Item
                label="Modifier Group in English"
                name="name_english"
                rules={[
                  {
                    required: true,
                    message: "Please enter your modifier group in english.",
                  },
                  {
                    max: 256,
                    message: "Maximum 256 characters",
                  },
                ]}
              >
                <Input
                  size="large"
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value, "text");
                    form.setFieldValue("name_english", value.trimStart());
                    handleInputChange("name_english");
                  }}
                />
              </Form.Item>
              <Form.Item
                label="Modifier Group in Arabic"
                name="name_arabic"
                rules={[
                  {
                    required: true,
                    message: "Please enter your modifier group in arabic.",
                  },
                  {
                    max: 256,
                    message: "Maximum 256 characters",
                  },
                ]}
              >
                <Input
                  size="large"
                  onChange={(e) => {
                    let value = Validation.strFormat(e.target.value, "text");
                    form.setFieldValue("name_arabic", value.trimStart());
                    handleInputChange("name_arabic");
                  }}
                />
              </Form.Item>
            </div>
          </div>
          <div className="my-4">
            <h4 className="text-[16px] font-semibold">Modifier type & minimum/maximum</h4>
            <p className="text-[#808080] text-sm">
              This will allow the customer to choose single/multiple selections from the modifier grouping & Select the minimum/maximum
              number of modifiers a customer must select for this modifier group.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4">
              <Form.Item
                label="Modifier Type"
                name="type"
                rules={[
                  {
                    required: true,
                    message: "Please select your modifier type.",
                  },
                ]}
              >
                <Select
                  mode="single"
                  size="large"
                  placeholder="Select"
                  options={allModifierType}
                  showSearch
                  filterOption={(input, allModifierType) => (allModifierType?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                />
              </Form.Item>
              <div className="block sm:flex gap-6">
                <div className="w-full max-w-[250px]">
                  <Form.Item label="Minimum" name="minimum">
                    <div className=" bg-[#F7F5F2] flex justify-center items-center gap-8 p-2.5 rounded-lg border border-[#d9d9d9]">
                      <button type="button" onClick={handleMinimumDecrease}>
                        <MinusOutlined />
                      </button>
                      <h2 className="font-semibold">{countMinimum}</h2>
                      <button type="button" onClick={handleMinimumIncrease} style={{ marginRight: "10px" }}>
                        <PlusOutlined />
                      </button>
                    </div>
                  </Form.Item>
                </div>
                <div className="w-full max-w-[250px]">
                  <Form.Item label="Maximum" name="maximum">
                    <div className="bg-[#F7F5F2] flex justify-center items-center gap-8 p-2.5 rounded-lg border border-[#d9d9d9]">
                      <button type="button" onClick={handleMaximumDecrease}>
                        <MinusOutlined />
                      </button>
                      <h2 className="font-semibold">{countMaximum}</h2>
                      <button type="button" onClick={handleMaximumIncrease} style={{ marginRight: "10px" }}>
                        <PlusOutlined />
                      </button>
                    </div>
                  </Form.Item>
                </div>
              </div>
            </div>
          </div>
          <div className="my-4">
            <h4 className="text-[16px] font-semibold">Active/Inactive</h4>
            <p className="text-[#808080] text-sm mb-4">
              You can easily active or inactive this modifier at any point of time. Its reflections will not appear on the existing placed
              orders. The inactive modifiers will not appear in the list while creating a new order and add product.
            </p>
            <Switch //setActive
              checked={active === 1 ? true : false}
              onChange={() => {
                setActive(active === 0 ? 1 : 0);
              }}
            />
          </div>

          <div className="my-4">
            <h4 className="text-[16px] font-semibold mt-5">Items</h4>
            <p className="text-[#808080] text-sm">
              How many numbers of items you want to add for above modifier group. You can set modifier name, price, prep time for that item.
              You can give name like Chocolate, Strawberry, Blackberry, Caramel.
            </p>
            {formItems.map((item, index) => (
              <div key={`${item?.itemid}${index}`} className="grid grid-cols-1 sm:grid-cols-4 gap-4 mt-4">
                <Form.Item
                  label="Name in English"
                  name={`Name_English_${index}`}
                  rules={[
                    {
                      required: true,
                      message: "Please enter name in english.",
                    },
                    { max: 50, message: "Maximum 50 characters" },
                  ]}
                >
                  <Input
                    size="large"
                    onChange={(e) => {
                      let nameEnglish = e.target?.value?.trimStart();
                      handleChangeFormItems("item_name_english", nameEnglish, index);
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label="Name in Arabic"
                  name={`Name_Arabic_${index}`}
                  rules={[
                    {
                      required: true,
                      message: "Please enter name in arabic.",
                    },
                    { max: 50, message: "Maximum 50 characters" },
                  ]}
                >
                  <Input
                    size="large"
                    onChange={(e) => {
                      let nameArabic = e.target?.value?.trimStart();
                      handleChangeFormItems("item_name_arabic", nameArabic, index);
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label="Price"
                  name={`Price_${index}`}
                  rules={[
                    // { required: true, message: "Please enter price." },
                    {
                      pattern: /^[0-9]+$/,
                      message: "Please enter a valid price.",
                    },
                    // { max: 30, message: "Maximum 30 characters" },
                  ]}
                >
                  <Input
                    size="large"
                    onChange={(e) => {
                      let price = Validation.strFormat(e.target.value, "number");
                      handleChangeFormItems("price", price, index);
                    }}
                  />
                </Form.Item>
                <div className="flex gap-3">
                  <Form.Item
                    label="Prep Time(in min)"
                    name={`Prep_Time_${index}`}
                    rules={[
                      {
                        pattern: /^[0-9]+$/,
                        message: "Please enter a valid time.",
                      },
                      // { max: 30, message: "Maximum 30 characters" },
                    ]}
                  >
                    <Input
                      size="large"
                      onChange={(e) => {
                        let prepTime = e.target.value.replace(/[^0-9]/g, ""); // Allow only numbers
                        handleChangeFormItems("prep_time", prepTime, index);
                      }}
                    />
                  </Form.Item>
                  <DeleteOutlined className="text-lg cursor-pointer" onClick={() => handleRemove(index)} />
                </div>
              </div>
            ))}
            <Button type="primary" htmlType="button" className="w-full" onClick={handleAddMore}>
              Add more item
            </Button>
          </div>
        </Form>
        <div className="flex justify-end gap-3">
          <Button onClick={() => {
            sessionStorage.setItem('previousPath', location.pathname);
            navigate("/manage-modifiers")}}>Cancel</Button>
          <Button type="primary" htmlType="submit" onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      </div>
    </>
  );
};
export default ModifierGroupType;
